import React from 'react'
import {Icon} from '@chakra-ui/react'
const DiscountIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_694_1366)">
                <path
                    d="M7.72007 3.5648V15.3269L25.6736 33.2805L37.4358 21.5184L19.4822 3.5648H7.72007ZM5.15527 3.5648C5.15527 2.1483 6.30357 1 7.72007 1H19.4822C20.1624 1.00015 20.8147 1.27046 21.2955 1.75148L39.2491 19.7051C40.2503 20.7066 40.2503 22.3301 39.2491 23.3317L27.4869 35.0938C26.4854 36.0951 24.8619 36.0951 23.8603 35.0938L5.90676 17.1403C5.42573 16.6594 5.15542 16.0071 5.15527 15.3269V3.5648Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="0.0184665"
                    strokeLinecap="round"
                />
                <path
                    d="M14.1064 11.2592C13.3981 11.2592 12.824 10.685 12.824 9.97678C12.824 9.26853 13.3981 8.69438 14.1064 8.69438C14.8146 8.69438 15.3888 9.26853 15.3888 9.97678C15.3888 10.685 14.8146 11.2592 14.1064 11.2592ZM14.1064 13.824C16.2311 13.824 17.9536 12.1015 17.9536 9.97678C17.9536 7.85203 16.2311 6.12958 14.1064 6.12958C11.9816 6.12958 10.2592 7.85203 10.2592 9.97678C10.2592 12.1015 11.9816 13.824 14.1064 13.824ZM2.5648 16.6093C2.56494 17.2895 2.83525 17.9418 3.31628 18.4226L22.442 37.5483L22.3317 37.6586C21.3301 38.6599 19.7066 38.6599 18.7051 37.6586L0.751485 19.705C0.270459 19.2242 0.000145263 18.5719 0 17.8917L0 6.12958C0 4.71309 1.1483 3.56479 2.5648 3.56479V16.6093Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="0.0184665"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_694_1366">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default DiscountIcon
